<section class="container-fluid p-0  main-callout">
    <div class="d-flex flex-column justify-content-around align-items-center position-absolute top-50 start-50 translate-middle">
        <h2 class="text-center text-light text-shadow display-4">Building stronger families,</h2>
        <h2 class="text-center text-light text-shadow display-4">one healthy step at a time.</h2>
        <a class="btn bg-white text-dark btn-lg shadow-lg border-dark rounded-0 mt-5" [routerLink]="['/patients']" fragment="joinNow">JOIN NOW</a>
    </div>
</section>
<section class="container-fluid bg-black">
    <div class="container pt-5">
      <div class="row">
        <div class="col-md-10 offset-md-1  my-5 text-white">
          <div class="mb-4">
            <p class="fs-5">
              At <span class="fw-bold">Family Health Advantage</span> we believe that access to affordable healthcare is a right, not a privilege.
              Guided by the principles of health, unity, and reliability, we offer a discount medical plan designed to 
              ease the burden of healthcare costs for families who do not have insurance or have exhausted their annual benefits.
            </p>
          </div>

          <div class="mb-4">
            <p class="fs-5">
              <span class="fw-bold">Our mission is simple:</span> Building stronger families, one healthy step at a time.  
              We partner with trusted providers to give our members access to quality care at reduced rates—
              empowering communities to live healthier without financial strain.
            </p>
          </div>

          <div>
            <p class="fs-5 mb-5">
              Join us on a journey where <span class="fw-bold">health is prioritized</span>, and families come first.
            </p>
          </div>

        </div>
    </div>
    </div>
</section>
<section class="container-fluid bg-white bg-pattern-tile">
    <div class="container pt-5">
        <div class="row">
            @for (callout of callouts; track callout) {
            <section class="col-md-4">
                <article class="d-flex flex-column align-items-center">
                    <i [class]="callout.icon" style="font-size:6rem;"></i>
                    <h4 class="mb-0">{{callout.title}}</h4>
                    <p class="text-center fs-6 p-5 pt-4">
                      {{callout.description}}
                    </p>
                </article>
            </section>
          }
        </div>
    </div>
</section>
